import { EquipmentCalculatorSectionKey } from "@/composables/scenarioCalculations/calculationTypes";
import {
  Severity,
  valuesExist,
  type ValidationRuleGenerator
} from "../scenarioValidator";
import { Sizing_Pumping_Type_Enum } from "gql/api";

export const sealMotorOilChecksNames = [
  "seal_motor_oil_temp_exceeded"
] as const;

export const sealMotorOilChecks: ValidationRuleGenerator = ({
  calcs,
  equipment,
  scenario
}) => {
  // Only apply to ESP sizings
  const isEspSizing =
    scenario.value?.pumping_type === Sizing_Pumping_Type_Enum.EspOnShore;

  return [
    {
      name: "seal_motor_oil_temp_exceeded",
      message: `Internal Motor Temperature exceeds rated limit. Please select higher rated oil.`,
      severity: Severity.error,
      isActive:
        isEspSizing &&
        valuesExist([
          equipment.value?.r_seal_motor_oil?.id,
          equipment.value?.r_motor?.id,
          calcs.motorCalculations.motorInternalTemperatureF.value
        ]),
      isInvalid:
        calcs.motorCalculations.motorInternalTemperatureF.value >
        (equipment.value?.r_seal_motor_oil?.max_temp_fahrenheit || 0),
      rulePlacement: EquipmentCalculatorSectionKey.SEAL_MOTOR_OIL
    }
  ];
};
